module.exports = __webpack_public_path__ + "img/team-leader.e4903cd4.svg";